import FormWrapper from 'components/Form/FormWrapper'
import styled from 'styled-components'
import HistoryTable from './components/HistoryTable'
import FilterForm from './components/FilterForm'
import { useCallback, useEffect, useState } from 'react'
import { orderService } from 'services'
import { useLocation, useHistory } from 'react-router-dom'
import * as qs from 'query-string'

const WrapperPage = styled.div`
  min-height: 77vh;
  width: 100%;
  padding: 0 20px 40px;
`

const Page = () => {
  const location = useLocation()
  const history = useHistory()

  const [dataList, setDataList] = useState<any>()
  const [loadingSearch, setLoadingSearch] = useState<boolean>(false)
  const [listSelectedOrder, setListSelectedOrder] = useState<any[]>([])
  const [params, setParams] = useState<any>(() => {
    const query = qs.parse(location.search)
    return {
      page: Number(query.page) || 1,
      per_page: Number(query.per_page) || 25,
      order_code: query.order_code || undefined,
      full_name: query.full_name || undefined,
      phone_number: query.phone_number || undefined
    }
  })
  useEffect(() => {
    const query = qs.parse(location.search)
    setParams({
      page: Number(query.page) || 1,
      per_page: Number(query.per_page) || 25,
      order_code: query.order_code || undefined,
      full_name: query.full_name || undefined,
      phone_number: query.phone_number || undefined
    })
  }, [])
  useEffect(() => {
    if (params) {
      const queryString = qs.stringify(params)
      history.push({
        pathname: history.location.pathname,
        search: queryString ? `?${queryString}` : '',
      })
    }
  }, [history, params])

  const searchOrder = useCallback(() => {
    if (params) {
      orderService.searchOrderComplete(params, (data) => {
        setDataList(data)
        setLoadingSearch(false)
      })
    }
  }, [params])

  useEffect(() => {
    searchOrder()
  }, [searchOrder])


  return (
    <WrapperPage>
      <p className='title-page'>Đơn vận hoàn tất</p>

      <FormWrapper>
        <FilterForm
          setParams={setParams}
          params={params}
          listSelectedOrder={listSelectedOrder}
          setListSelectedOrder={setListSelectedOrder}
          setLoadingSearch={setLoadingSearch}
          loadingSearch={loadingSearch}
        />
        <HistoryTable
          dataList={dataList}
          setParams={setParams}
          setListSelectedOrder={setListSelectedOrder}
          listSelectedOrder={listSelectedOrder}
          searchOrder={searchOrder}
        />
      </FormWrapper>
    </WrapperPage>
  )
}

export default Page
